<div class="flex flex-col gap-5" *transloco="let t; read 'customer.saved_power_plants.details'">
  <div class="flex flex-col items-center gap-10">
    <div class="flex flex-col gap-4 w-full flex-1">
      <div class="flex gap-1 [&>*]:text-3xl  [&>*]:text-color-blue1">
        <mat-icon class="!w-fit !h-fit">location_on</mat-icon>
        <div>
          {{powerPlant.address}}
        </div>
      </div>
      <img
        [src]="(powerPlant.locationPicture ? ('data:image/jpg;base64,' + powerPlant.locationPicture) : 'assets/images/solar-panels-roof-green.webp')"
        alt="Slika objekta"/>
    </div>
    <div class="flex flex-col w-full flex-1">

      <psc-section-title
        [title]="t('input_parameters')"
        alignment="left"
        size="normal"
        [lineWidthPercentage]="100"
        [lineThickness]="2"></psc-section-title>

      <div class="flex flex-col">
        <!-- t(customer.saved_power_plants.details.value.country.title,customer.saved_power_plants.details.value.contractor.title,customer.saved_power_plants.details.value.tariff_model.title)  -->
        <!--  t(customer.saved_power_plants.details.value.tilt.title,customer.saved_power_plants.details.value.azimuth.title)-->
        <!--  t(customer.saved_power_plants.details.value.area.title,customer.saved_power_plants.details.value.investment.title)-->
        <!-- t(customer.saved_power_plants.details.value.country.info,customer.saved_power_plants.details.value.contractor.info,customer.saved_power_plants.details.value.tariff_model.info)  -->
        <!--  t(customer.saved_power_plants.details.value.tilt.info,customer.saved_power_plants.details.value.azimuth.info)-->
        <!--  t(customer.saved_power_plants.details.value.area.info,customer.saved_power_plants.details.value.investment.info)-->

        <ng-container
          *ngFor="let value of valuesList; let even = even">
          <psc-value-text
            *ngIf="value.value || value.stringValue; else emptyValue"
            [coloredRow]="even"
            [label]="t('value.' + value.labelKey + '.title')"
            [infoText]="t('value.' + value.labelKey + '.info')"
            [value]="value.value"
            [stringValue]="value.translatePrefix ? (value.translatePrefix + value.stringValue | transloco) : value.stringValue"
            [unit]="value.unit"
          ></psc-value-text>
          <ng-template #emptyValue>
            <psc-value-text
              [coloredRow]="even"
              [label]="t('value.' + value.labelKey + '.title')"
              [infoText]="t('value.' + value.labelKey + '.info')"
              stringValue="-"
            ></psc-value-text>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</div>
